module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qskel11-89f875db16e03814706796b8f61af717.jpg";